import { useEffect, useRef } from 'react';

import { useDelegationStore } from '@/store';
import type { Tenant } from '@/type';

type DelegationProviderProps = {};

const DelegationProvider = ({
  children,
}: React.PropsWithChildren<DelegationProviderProps>) => {
  const referrer = useRef(document.referrer);
  const { clear: clearDelegationStore, setDelegationTenant } =
    useDelegationStore();

  useEffect(() => {
    if (
      (referrer.current.match(/vuex.vueron.ai/) || import.meta.env.DEV) &&
      !location.pathname.startsWith('/auth')
    ) {
      const searchParams = new URLSearchParams(location.search);
      const tenant = JSON.parse(searchParams.get('tenant') ?? '{}') as Pick<
        Tenant,
        'accessPath' | 'tenantID' | 'tenantName' | 'tier' | 'region'
      >;

      if (!tenant.tenantID) {
        clearDelegationStore();
        return;
      }

      setDelegationTenant(tenant);
    } else {
      clearDelegationStore();
    }
  }, []);

  return <>{children}</>;
};

DelegationProvider.displayName = 'DelegationProvider';

export default DelegationProvider;
